export enum UserSigninStatus {
    Idle = 1,
    Assisting = 2,
    Offline = 3,
    SignOut = 4,
}